import { Form, Input } from 'antd';
import i18n from 'i18next';
import { getShipmentAllAccessorialsEffect } from '../../../../redux/shipment/ShipmentEffects';
import FormSelectBox from '../../Inputs/FormSelectBox';

const AccessorialSelector = ({
  placeholder = i18n.t('translation:default.fields.accessorial.placeholder'),
  label = i18n.t('translation:default.fields.accessorial.label'),
  rules = [],
  name,
  form = {},
  disabled = false,
  margin = 'mb-0',
  editMode = true,
  inputValue,
  defaultOptions,
  onChange = () => {},
  hasError = false,
}) => {
  Form.useWatch(name, form); // To re-render the component once the value is updated
  return (
    <>
      <FormSelectBox
        hasError={hasError}
        defaultOptions={defaultOptions}
        disabled={disabled}
        placeholder={placeholder}
        label={label}
        margin={margin}
        rules={rules}
        asyncFetchMode
        asyncFunction={getShipmentAllAccessorialsEffect}
        defaultParams={{
          PageSize: 10,
          PageNumber: 1,
        }}
        onChange={onChange}
        value={inputValue ? inputValue : form.getFieldValue(name)}
        accessors={{ label: 'codeDesc', value: 'codeId' }}
        onClear={() => form.setFieldsValue({ [name]: undefined })}
        editMode={editMode}
      />
      <Form.Item className="m-0" name={name} rules={rules}>
        <Input className="d-none" />
      </Form.Item>
    </>
  );
};

export default AccessorialSelector;
